import api from './index'
import request from '@/utils/request'
/**
 * @description 活动金信息管理
 */
export function listSubsidy (data) {
  return request({
    url: `${api.listSubsidy}`,
    method: 'post',
    data
  })
}
/**
 * @description 活动金金录入或修改
 */
export function addOrUpdateSubsidy (data) {
  return request({
    url: `${api.addOrUpdateSubsidy}`,
    method: 'post',
    data
  })
}
/**
 * @description 活动金查看
 */
export function getSgentSubsidyDetail (data) {
  return request({
    url: `${api.getSgentSubsidyDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 活动金变动列表
 */
export function subsidyMoneyChange (data) {
  return request({
    url: `${api.subsidyMoneyChange}`,
    method: 'post',
    data
  })
}
/**
* @description 活动金变动列表 详情
*/
export function subsidyMoneyDeductDetail (data) {
  return request({
    url: `${api.subsidyMoneyDeductDetail}`,
    method: 'post',
    data
  })
}
/**
* @description 补贴文件管理
*/
export function subsidyInfo (data) {
  return request({
    url: `${api.subsidyInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 补贴文件详情
*/
export function subsidyInfoDetail (data) {
  return request({
    url: `${api.subsidyInfoDetail}`,
    method: 'post',
    data
  })
}
/**
* @description 确认或废弃 代理商补贴文件
*/
export function confirmDestroySubsidy (data) {
  return request({
    url: `${api.confirmDestroySubsidy}`,
    method: 'post',
    data
  })
}
/**
* @description 补贴文件详情 导出
*/
export function exportSubsidyFileDetail (data) {
  return request({
    url: `${api.exportSubsidyFileDetail}`,
    method: 'post',
    data
  })
}
/**
* @description 代理商代金券统计列表接口
*/
export function agentListWxcoupon (data) {
  return request({
    url: `${api.agentListWxcoupon}`,
    method: 'post',
    data
  })
}
/**
* @description 银联活动活动信息列表
*/
export function unionActivityList (data) {
  return request({
    url: `${api.unionActivityList}`,
    method: 'post',
    data
  })
}
/**
* @description 银联活动提交报名资料
*/
export function unionActivityUpdateInfo (data) {
  return request({
    url: `${api.unionActivityUpdateInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 银联活动重新报名
*/
export function unionActivitySignUp (data) {
  return request({
    url: `${api.unionActivitySignUp}`,
    method: 'post',
    data
  })
}
/**
* @description 银联活动列表导出
*/
export function exportUnionActivity (data) {
  return request({
    url: `${api.exportUnionActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 银联活动列表导出
*/
export function merchantListWxcoupon (data) {
  return request({
    url: `${api.merchantListWxcoupon}`,
    method: 'post',
    data
  })
}
/**
* @description 代理商奖励计划列表
*/
export function getRewardList (data) {
  return request({
    url: `${api.getRewardList}`,
    method: 'post',
    data
  })
}
/**
* @description 代理商a++奖励列表导出
*/
export function exportReward (data) {
  return request({
    url: `${api.exportReward}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}
/**
* @description 查看奖励发放分段列表
*/
export function getStageList (data) {
  return request({
    url: `${api.getStageList}`,
    method: 'post',
    data
  })
}
/**
* @description 发票详情
*/
export function queryInvoiceDetail (data) {
  return request({
    url: `${api.queryInvoiceDetail}`,
    method: 'post',
    data
  })
}
/**
* @description 申请奖励详情
*/
export function applyRewardDetail (data) {
  return request({
    url: `${api.applyRewardDetail}`,
    method: 'post',
    data
  })
}
/**
* @description 发票录入
*/
export function writeInvoiceInfo (data) {
  return request({
    url: `${api.writeInvoiceInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 发票图片上传
*/
export function uploadInvoiceImage (data) {
  return request({
    url: `${api.uploadInvoiceImage}`,
    method: 'post',
    data
  })
}
/**
* @description 申请奖励提交
*/
export function applyReward (data) {
  return request({
    url: `${api.applyReward}`,
    method: 'post',
    data
  })
}
/**
* @description 查询微信活动列表
*/
export function getWechatActivityList (data) {
  return request({
    url: `${api.getWechatActivityList}`,
    method: 'post',
    data
  })
}
/**
* @description 查询微信活动商户列表
*/
export function getWechatMerchantList (data) {
  return request({
    url: `${api.getWechatMerchantList}`,
    method: 'post',
    data
  })
}
/**
* @description 获取商户报名记录
*/
export function getWechatAuditList (data) {
  return request({
    url: `${api.getWechatAuditList}`,
    method: 'post',
    data
  })
}
/**
* @description 导出微信活动列表
*/
export function exportWechatActivity (data) {
  return request({
    url: `${api.exportWechatActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 更新报名状态
*/
export function updateAuditState (data) {
  return request({
    url: `${api.updateAuditState}`,
    method: 'post',
    data
  })
}
/**
* @description 重新报名
*/
export function reSignActivity (data) {
  return request({
    url: `${api.reSignActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 报名活动
*/
export function signActivity (data) {
  return request({
    url: `${api.signActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 批量报名活动
*/
export function batchSignActivity (data) {
  return request({
    url: `${api.batchSignActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 前置代理商批量报名活动
*/
export function batchSignFrontActivity (data) {
  return request({
    url: `${api.batchSignFrontActivity}`,
    method: 'post',
    data
  })
}
/**
* @description 获取报名信息
*/
export function getSignInfo (data) {
  return request({
    url: `${api.getSignInfo}`,
    method: 'post',
    data
  })
}
/**
* @description 提交报名信息
*/
export function submitSignInfo (data) {
  return request({
    url: `${api.submitSignInfo}`,
    method: 'post',
    data
  })
}
